<template>
  <sfs-form-modal
    :id="modalId"
    size="md"
    title="Import Tax Rates"
    @on-hide="resetFormData"
  >
    <imports-form
      description="Create tax rates. Optional effective_date column controls when taxes apply."
      @on-submit="createTaxRateImport"
      @on-save="handleSave"
      @on-cancel="closeModal"
      :key="formKey"
    >
      <template #downloads>
        <b-row>
          <b-col cols="12">
            <sfs-download-button
              label="Download Template"
              filename="Tax Rates Template.xlsx"
              :file-provider="$importsAPI.getTaxRatesTemplate"
            />
          </b-col>
        </b-row>
      </template>
    </imports-form>
  </sfs-form-modal>
</template>

<script>
import ImportsForm from './Form.vue';
import formModalMixin from '@/mixins/formModalMixin';

export default {
  name: 'TaxRatesImportsAddModal',
  mixins: [formModalMixin],
  components: {
    ImportsForm,
  },
  data() {
    return {
      modalId: 'tax-rates-imports-add-modal',
    };
  },
  methods: {
    createTaxRateImport(data, handleCreate) {
      handleCreate(this.$importsAPI.taxRatesCreate(data));
    },
    handleSave(data) {
      if (this.$route.name != 'imports') {
        this.$router.push({ name: 'imports' });
      } else {
        this.closeModal();
      }
      this.$emit('on-save', data);
    },
  },
};
</script>
